const yenFormatter = new Intl.NumberFormat("ja-JP");

export function yen(value: number): string {
  return `¥${yenFormatter.format(value)}`;
}

/** "2026-10-18" -> "2026/10/18" */
export function formatDate(iso: string | null): string | null {
  return iso ? iso.replaceAll("-", "/") : null;
}

export const DURATION_OPTIONS = [
  { value: 60, label: "1時間" },
  { value: 120, label: "2時間" },
  { value: 180, label: "3時間" },
  { value: 240, label: "4時間" },
  { value: 300, label: "5時間" },
  { value: 360, label: "フリータイム" },
] as const;

export function durationLabel(minutes: number): string {
  return DURATION_OPTIONS.find((option) => option.value === minutes)?.label ?? `${minutes}分`;
}
